import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=078690dd&scoped=true&"
import script from "./ShareButton.vue?vue&type=script&lang=ts&"
export * from "./ShareButton.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=078690dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078690dd",
  null
  
)

export default component.exports